import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Ditta, Iaddress, Users } from 'my-lib-sanfelici/my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-ditta-edit',
  templateUrl: './ditta-edit.component.html',
  styleUrls: ['./ditta-edit.component.css']
})
export class DittaEditComponent implements OnInit {


user: Users;
id: string;
ditta: Ditta;
address: Iaddress;

  constructor(
    
    private router:Router,
    private route: ActivatedRoute,
    private usersservice: UsersService) {

    }

    onSubmit(user) {
    this.user.ditta =this.ditta;
    this.usersservice.update(this.user)
    .then(() => {
       this.router.navigate(['/myuser',  'ditta', 'details', this.id]);
        console.log(this.user);
       });

         }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.usersservice.details(this.id)
    .subscribe(u =>
      {
        if(u){
          if(u.ditta){
            this.user = u;
            this.ditta = this.user.ditta;
          }else{
            this.ditta={ragionesociale:null,codicefiscale:null,partitaiva:null}
          }
        }
       
      });
  }

}
